import React from 'react'

const History = ({Heestory}) => {
  return (
    <h2>{Heestory?.list}</h2>
  )
}

export default History